import * as yup from 'yup';
import YupPassword from 'yup-password';

YupPassword(yup);

export const createPasswordSchema = (requiredMessage?: string) =>
  yup.string().required(requiredMessage || 'Заполните оба поля');
// .min(8, 'Пароль не может быть короче 8 символов')
// .minLowercase(1, 'Пароль должен содержать хотя бы 1 строчную буква')
// .minUppercase(1, 'Пароль должен содержать хотя бы 1 заглавную буква')
// .minNumbers(1, 'Пароль должен содержать хотя бы 1 цифру')
// .minSymbols(1, 'Пароль должен содержать хотя бы 1 специальный символ');

export const newPasswordSchema = yup
  .object({
    password: createPasswordSchema(),
    passwordRepeat: yup
      .string()
      .required('Заполните оба поля')
      .oneOf([yup.ref('password')], 'Пароли не совпадают'),
  })
  .required();

export const resetPasswordSchema = yup
  .object({
    old_password: createPasswordSchema('Заполните все поля'),
    new_password: createPasswordSchema('Заполните все поля'),
    new_password_confirm: yup
      .string()
      .required('Заполните все поля')
      .oneOf([yup.ref('new_password')], 'Пароли не совпадают'),
  })
  .required();
